<template>
  <div class="row">
    <!--  练习题列表  -->
    <div class="flex xs12">
      <va-card title="练习题列表">
        <div class="row align--center mb-1">
          <div class="flex xs12">
            <va-button-group>
              <va-button disabled flat color="gray">职位类型: </va-button>
              <va-button flat :color="positionTagId !== null ? 'gray' : 'info'" v-on:click="handlePositionTagIdChange(null)">全部分类 </va-button>
              <va-button
                flat
                :color="positionTagId === val.id ? 'info' : 'gray'"
                :key="val.id" v-for="val in positionTags"
                v-on:click="handlePositionTagIdChange(val.id)"
              >{{val.name}} </va-button>
            </va-button-group>
            <va-button-group>
              <va-button disabled flat color="gray">发布状态: </va-button>
              <va-button
                flat
                :color="status === val.CODE ? 'info' : 'gray'"
                :key="val.CODE" v-for="val in statusOptions"
                v-on:click="handleStatusChange(val.CODE)"
              >{{val.TEXT}} </va-button>
            </va-button-group>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-input
              class="ma-0"
              :value="organizationName"
              placeholder="搜索公司名称"
              @input="searchOrganizationName"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-input
              class="ma-0"
              :value="question"
              placeholder="搜索题目名称"
              @input="searchQuestion"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" outline small :to='{name:`uploadPdf`}'>导入练习题PDF</va-button>
              <va-button color="info" outline small :to='{name:`savePracticeQuestion`}'>创建练习题</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="practiceQuestions"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listPracticeQuestion"
          api-mode
        >
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              v-bind:style="{margin: '1rem auto', width: '50%'}"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="question" slot-scope="props">
            <div>{{`${props.rowData.question.substring(0,10)}...`}}</div>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`updatePracticeQuestion/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除练习题"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import practiceQuestionApi from '../../api/interview/practiceQuestion'
import { STATUS_OPTIONS, INTERVIEW_TAG_TYPE } from '@/utils/constants'
import positionTagApi from '@/api/interview/positionTag'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      practiceQuestions: [],
      question: '',
      organizationName: '',
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
      organizationId: null,
      positionTagId: null,
      positionTags: [],
      status: 1,
      statusOptions: STATUS_OPTIONS,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:question',
          title: '练习题题目',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'organization',
          title: '企业名称',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listPracticeQuestion()
    this.listPositionTag()
  },
  methods: {
    listPracticeQuestion (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        question: this.question,
        name: this.name,
        positionTagId: this.positionTagId,
        organizationId: this.organizationId,
        status: this.status,
        organizationName: this.organizationName,
      }
      practiceQuestionApi.listPracticeQuestion(params).then(response => {
        this.practiceQuestions = response.practiceQuestions
        this.practiceQuestions.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error.msg))
    },
    listPositionTag () {
      const params = {
        type: INTERVIEW_TAG_TYPE.POSITION_TAG.CODE,
      }
      positionTagApi.listPositionTag(params).then(response => {
        this.positionTags = response.tags
      }).catch(error => this.showToast('获取职位失败: ' + error.msg, {
        duration: 1000,
        icon: 'fa-check',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    confirmDelete () {
      if (this.deleteId === null) return
      practiceQuestionApi.deletePracticeQuestion(this.deleteId).then(response => {
        if (response.success === true) {
          this.listPracticeQuestion()
        }
      }).catch(error => alert(error.msg))
    },
    searchQuestion: debounce(function (question) {
      this.question = question
      this.listPracticeQuestion()
    }, 400),
    searchOrganizationName: debounce(function (organizationName) {
      this.organizationName = organizationName
      this.listPracticeQuestion()
    }, 400),
    updateSortNum: function (params) {
      const data = {
        sortNum: params.sortNum,
      }
      practiceQuestionApi.updatePracticeQuestion(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listPracticeQuestion()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    handleStatusChange (status) {
      this.status = status
      this.listPracticeQuestion()
    },
    handlePositionTagIdChange (id) {
      this.positionTagId = id
      this.listPracticeQuestion()
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
